import { render, staticRenderFns } from "./EmailAuditDetail.vue?vue&type=template&id=71a7edc8&"
import script from "./EmailAuditDetail.vue?vue&type=script&lang=ts&"
export * from "./EmailAuditDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports